/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grow_Plus_Exclusive_TreeInputs */

const en_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enjoy Plus Exclusive Trees`)
};

const ar_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نَمِّى أشجار حصرية من بلس`)
};

const de_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genieße exklusive Plus-Bäume`)
};

const es_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disfruta de los Árboles exclusivos Plus`)
};

const fr_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez des arbres exclusifs Plus`)
};

const it_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goditi gli alberi esclusivi Plus`)
};

const ja_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus限定の木を楽しもう`)
};

const ko_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 전용 나무를 즐겨보세요`)
};

const pt_br_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite Árvores exclusivas Plus`)
};

const ru_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наслаждайтесь эксклюзивными деревьями Plus`)
};

const th_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพลิดเพลินกับต้นไม้สุดพิเศษสำหรับ Plus`)
};

const tr_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus’a Özel Ağaçların keyfini çıkarın`)
};

const zh_cn_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独享 Plus 限定树种`)
};

const zh_tw_grow_plus_exclusive_tree = /** @type {(inputs: Grow_Plus_Exclusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獨享 Plus 限定樹種`)
};

/**
* | output |
* | --- |
* | "Enjoy Plus Exclusive Trees" |
*
* @param {Grow_Plus_Exclusive_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const grow_plus_exclusive_tree = /** @type {((inputs?: Grow_Plus_Exclusive_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grow_Plus_Exclusive_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_grow_plus_exclusive_tree(inputs)
	if (locale === "ar") return ar_grow_plus_exclusive_tree(inputs)
	if (locale === "de") return de_grow_plus_exclusive_tree(inputs)
	if (locale === "es") return es_grow_plus_exclusive_tree(inputs)
	if (locale === "fr") return fr_grow_plus_exclusive_tree(inputs)
	if (locale === "it") return it_grow_plus_exclusive_tree(inputs)
	if (locale === "ja") return ja_grow_plus_exclusive_tree(inputs)
	if (locale === "ko") return ko_grow_plus_exclusive_tree(inputs)
	if (locale === "pt_br") return pt_br_grow_plus_exclusive_tree(inputs)
	if (locale === "ru") return ru_grow_plus_exclusive_tree(inputs)
	if (locale === "th") return th_grow_plus_exclusive_tree(inputs)
	if (locale === "tr") return tr_grow_plus_exclusive_tree(inputs)
	if (locale === "zh_cn") return zh_cn_grow_plus_exclusive_tree(inputs)
	return zh_tw_grow_plus_exclusive_tree(inputs)
});